var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.00001 15.4954L0.98787 8.48322L2.63779 6.8333L8.00001 12.1955L13.3622 6.8333L15.0122 8.48322L8.00001 15.4954Z","key":0}),React.createElement("path",{"d":"M8.00001 9.16664L0.987869 2.15449L2.63779 0.504578L8.00001 5.8668L13.3622 0.504578L15.0122 2.15449L8.00001 9.16664Z","key":1})]);
}

ArrowDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
